<form class="flex flex-column gap-4" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2 class="text-xl font-semibold text-color m-0">Antecedentes de iglesia</h2>

  <div class="grid">
    <div class="col-12 md:col-6 flex flex-column gap-3">
      <div class="flex flex-column gap-1 align-items-center text-center">
        <label class="text-sm font-semibold text-color m-0" for="persona-iba-iglesia">
          ¿Antes iba a una iglesia?
        </label>
        <div class="flex align-items-center justify-content-center gap-2 w-full pt-1">
          <span class="text-sm text-color-secondary">No</span>
          <p-toggleswitch inputId="persona-iba-iglesia" formControlName="ibaIglesia" />
          <span class="text-sm text-color-secondary">Sí</span>
        </div>
      </div>

      @if (form.controls.ibaIglesia.value) {
        <div class="flex flex-column gap-1 align-items-center text-center">
          <label class="text-sm font-semibold text-color m-0" for="persona-acepto-jesus">
            ¿Ya aceptó a Jesús en su corazón?
          </label>
          <div class="flex align-items-center justify-content-center gap-2 w-full pt-1">
            <span class="text-sm text-color-secondary">No</span>
            <p-toggleswitch inputId="persona-acepto-jesus" formControlName="aceptoJesus" />
            <span class="text-sm text-color-secondary">Sí</span>
          </div>
        </div>
      }

      <div class="flex flex-column gap-1 align-items-center text-center">
        <label class="text-sm font-semibold text-color m-0" for="persona-bautizado">
          ¿Está bautizado?
        </label>
        <div class="flex align-items-center justify-content-center gap-2 w-full pt-1">
          <span class="text-sm text-color-secondary">No</span>
          <p-toggleswitch inputId="persona-bautizado" formControlName="bautizado" />
          <span class="text-sm text-color-secondary">Sí</span>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6 flex flex-column gap-3">
      @if (form.controls.ibaIglesia.value) {
        <div class="flex flex-column gap-1">
          <label class="text-sm font-semibold text-color" for="persona-iglesia-anterior">
            Nombre de la iglesia anterior
            <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input
            pInputText
            id="persona-iglesia-anterior"
            formControlName="iglesiaAnterior"
            placeholder="Ej: El Buen Pastor"
            class="w-full agregar-persona-step__underline"
            [class.ng-invalid]="showFieldError('iglesiaAnterior')"
            [class.ng-dirty]="form.controls.iglesiaAnterior.touched"
          />
          @if (showFieldError('iglesiaAnterior')) {
            <small class="text-red-500 text-xs">El nombre de la iglesia es obligatorio.</small>
          }
        </div>

        <div class="flex flex-column gap-1">
          <label class="text-sm font-semibold text-color" for="persona-tiempo-iglesia">
            ¿Cuánto tiempo asistió a la iglesia anterior?
            <span class="text-red-500" aria-hidden="true">*</span>
          </label>
          <input
            pInputText
            id="persona-tiempo-iglesia"
            formControlName="tiempoIglesia"
            placeholder="Ej: 2 años, 6 meses"
            class="w-full agregar-persona-step__underline"
            [class.ng-invalid]="showFieldError('tiempoIglesia')"
            [class.ng-dirty]="form.controls.tiempoIglesia.touched"
          />
          @if (showFieldError('tiempoIglesia')) {
            <small class="text-red-500 text-xs">El tiempo de asistencia es obligatorio.</small>
          }
        </div>
      }
    </div>
  </div>

  <div class="flex flex-column-reverse md:flex-row justify-content-between gap-3 pt-3">
    <p-button
      type="button"
      label="Anterior"
      icon="pi pi-arrow-left"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full md:w-auto"
      (onClick)="back.emit()"
    />
    <p-button
      type="submit"
      label="Siguiente"
      icon="pi pi-arrow-right"
      iconPos="right"
      styleClass="w-full md:w-auto uppercase"
      [disabled]="form.invalid"
    />
  </div>
</form>
